import { gql } from '@apollo/client';

export * from './contactCreate.mutation.generated';

export const CONTACT_CREATE = gql`
  mutation contactCreate($escrowPartyId: ID!, $contactParams: ContactCreateParams!) {
    contactCreate(input: { escrowPartyId: $escrowPartyId, contactParams: $contactParams }) {
      success
      errors
      contact {
        ...ContactFragment
        escrow {
          id
          depositorConfigured
          beneficiaryConfigured
          agreement {
            policy {
              generate
            }
          }
        }
      }
    }
  }
`;
